/*
 * @Author: shaozongyao
 * @Date: 2021-11-28 11:31:22
 * @LastEditTime: 2021-11-30 08:40:08
 * @LastEditors: your name
 */
import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'
import {
  unAuth
} from '@/utils/handle_app'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 500000
})

const category = navigator.userAgent
const isAndroid = category.indexOf('Android') > -1 || category.indexOf('Adr') > -1 // android终端
const isiOS = !!category.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // i

let loading = null
let showLoading = true
instance.interceptors.request.use(config => {
  const token = store.state.auth.token

  // 是否是小程序环境
  if (window.__wxjs_environment === 'miniprogram') {
    config.headers.authorization = token
  } else {
    config.headers.token = token
  }

  if (loading) loading.clear()
  if (config.unLoading) {
    showLoading = false
  }
  if (showLoading) {
    loading = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
  }
  return config
}, error => {
  return Promise.reject(error)
})

const irregularApiList = ['/data/brand.json', '/data/city.json']

instance.interceptors.response.use(response => {
  if (loading) {
    loading.clear()
    loading = null
  }
  if (irregularApiList.includes(response.config.url)) {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    }
  } else {
    if (response.data.code === '000000') {
      return Promise.resolve(response.config.returnEnvelope ? response.data : response.data.data)
    } else {
      switch (response.data.code) {
        case '-1':
          Toast(response.data.msg)
          break
        case '401':
          Toast('登录超时,请重新登录')
          if (isAndroid) {
            unAuth()
          }
          if (isiOS || isiOS.length) {
            window.webkit.messageHandlers.unAuth.postMessage(401)
          }

          break
        default:
          Toast(response.data.msg)
      }

      return Promise.reject(
        new Error(response.data.msg || '系统繁忙，请稍后再试!')
      )
    }
  }
}, error => {
  if (loading) {
    loading.clear()
    loading = null
  }
  const msg = `${error.message.indexOf('timeout') !== -1 ? '请求超时啦' : '系统繁忙'}，请稍候再试!`
  Toast(msg)
  return Promise.reject(error)
})

export default instance
